import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaCheck, FaDownload, FaPlay, FaChevronDown, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { SEO } from '../../components/SEO';
import { FaCheckCircle, FaCubes, FaExchangeAlt, FaRuler, FaSync, FaChartBar, FaLayerGroup } from 'react-icons/fa';
import BrandText from '../../styles/brandStyles';

const CuantificacionBIM = () => {
  const { translate } = useLanguage();
  const [activeSection, setActiveSection] = useState('overview');
  const [isSticky, setIsSticky] = useState(false);
  
  // Estados para controlar los carruseles
  const [activeCard1, setActiveCard1] = useState(0);
  const [activeCard2, setActiveCard2] = useState(0);
  const [activeCard3, setActiveCard3] = useState(0);

  // Datos para los carruseles
  const carouselData1 = [
    {
      image: "/images/modules/opus_m5/001 Minimiza el margen de error.png",
      title: "Minimiza el margen de error",
      description: "Obtén mediciones precisas directamente desde tu modelo BIM, reduciendo significativamente los errores en la cuantificación y estimación de costos de tu proyecto.",
      features: [
        "Cuantificación directa desde Revit®",
        "Minimiza errores en la estimación",
        "Precisión en los volúmenes de obra"
      ],
      link: "/caracteristicas/integracion-revit"
    },
    {
      image: "/images/modules/opus_m5/002 Aprovecha tus presupuestos ya elaborados .png",
      title: "Aprovecha tus presupuestos ya elaborados",
      description: "Reutiliza tus presupuestos existentes y conecta elementos BIM con conceptos previamente analizados en OPUS para ahorrar tiempo y mantener consistencia en tus proyectos.",
      features: [
        "Reutilización de presupuestos existentes",
        "Vinculación simple con elementos constructivos",
        "Aprovechamiento de análisis previos"
      ],
      link: "/caracteristicas/soporte-ifc"
    },
    {
      image: "/images/modules/opus_m5/003 Enlaza tus conceptos con los elementos constructivos.png",
      title: "Enlaza tus conceptos con los elementos constructivos",
      description: "Conecta fácilmente cada concepto de tu presupuesto con los elementos correspondientes en tu modelo BIM mediante un potente motor de búsqueda tipo Google®.",
      features: [
        "Motor de búsqueda avanzado",
        "Enlace intuitivo de conceptos",
        "Visualización del análisis del concepto"
      ],
      link: "/caracteristicas/visualizacion-3d"
    }
  ];

  const carouselData2 = [
    {
      image: "/images/modules/opus_m5/004 Envía los datos de tu cuantificación a M1 PRESUPUESTO PROGRAMABLE.png",
      title: "Envía los datos de tu cuantificación a M1 PRESUPUESTO PROGRAMABLE",
      description: "Transfiere automáticamente tus cuantificaciones BIM a OPUS M1 para generar presupuestos completos, manteniendo la organización por agrupadores y aprovechando toda la potencia del sistema.",
      features: [
        "Integración con OPUS M1",
        "Exportación a presupuestos nuevos o existentes",
        "Organización automática por agrupadores"
      ],
      link: "/caracteristicas/cuantificacion-automatica"
    },
    {
      image: "/images/modules/opus_m5/005 Identifica fácilmente los conceptos originados en tu modelo de Revit©.png",
      title: "Identifica fácilmente los conceptos originados en tu modelo de Revit©",
      description: "Mantén un seguimiento claro de qué elementos provienen de tu modelo Revit®, permitiéndote actualizar la información en cualquier momento que lo requieras.",
      features: [
        "Identificación clara de elementos BIM",
        "Actualización en tiempo real",
        "Control sobre modificaciones"
      ],
      link: "/caracteristicas/organizacion-elementos"
    },
    {
      image: "/images/modules/opus_m5/001 Minimiza el margen de error.png",
      title: "Cuantificación directa en TU MODELO de REVIT®",
      description: "Minimiza el margen de error al cuantificar directamente en tu modelo BIM, evitando recapturas innecesarias y asegurando la precisión de tus mediciones y costos.",
      features: [
        "Cuantificación directa en Revit®",
        "Interfaz intuitiva y centralizada",
        "Máximo aprovechamiento del sistema"
      ],
      link: "/caracteristicas/deteccion-cambios"
    }
  ];

  const carouselData3 = [
    {
      image: "/images/modules/opus_m5/003 Enlaza tus conceptos con los elementos constructivos.png",
      title: "Aprovecha tus modelos BIM al máximo",
      description: "Enlaza tus conceptos directamente con los elementos constructivos de tu modelo para establecer una conexión bidireccional que facilite la actualización y el seguimiento de cambios.",
      features: [
        "Eliminación de trabajo redundante",
        "Actualización automática con cambios",
        "Mayor eficiencia en el proceso"
      ],
      link: "/caracteristicas/presupuestacion-bim"
    },
    {
      image: "/images/modules/opus_m5/002 Aprovecha tus presupuestos ya elaborados .png",
      title: "Intuitivo y fácil de usar",
      description: "Aprovecha tus presupuestos ya elaborados y la interfaz intuitiva del sistema para agilizar el proceso de cuantificación y estimación, sin necesidad de volver a crear conceptos.",
      features: [
        "Curva de aprendizaje mínima",
        "Interfaz familiar para usuarios de Revit®",
        "Operación intuitiva"
      ],
      link: "/caracteristicas/planeacion-bim"
    },
    {
      image: "/images/modules/opus_m5/004 Envía los datos de tu cuantificación a M1 PRESUPUESTO PROGRAMABLE.png",
      title: "Flujo de trabajo BIM completo",
      description: "Envía los datos de tu cuantificación directamente a OPUS M1, creando un flujo de trabajo BIM completo que integra diseño, cuantificación y presupuestación en un solo sistema.",
      features: [
        "Ciclo BIM completo",
        "Integración perfecta entre sistemas",
        "Solución líder en la industria"
      ],
      link: "/caracteristicas/reportes-bim"
    }
  ];

  // Función para manejar el scroll y actualizar la sección activa
  useEffect(() => {
    const handleScroll = () => {
      // Detectar si el submenú debe ser sticky
      const heroSection = document.getElementById('overview');
      const headerHeight = 64; // Altura del header principal
      
      if (heroSection) {
        const heroBottom = heroSection.getBoundingClientRect().bottom;
        setIsSticky(heroBottom <= headerHeight);
      } else {
        // Si no se encuentra la sección, mantener el menú sticky para evitar que desaparezca
        setIsSticky(true);
      }

      // Detectar qué sección está visible
      const sections = ['overview', 'features', 'capabilities', 'benefits', 'cta'];
      let activeFound = false;
      
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          const offset = 140; // Altura del header + submenu
          if (rect.top <= offset && rect.bottom >= offset) {
            setActiveSection(section);
            activeFound = true;
            break;
          }
        }
      }
      
      // Si no se encuentra ninguna sección activa, mantener la última activa
      if (!activeFound && window.scrollY > 0) {
        // Mantener la sección activa anterior o establecer una por defecto
        setIsSticky(true);
      }
    };

    // Ejecutar handleScroll inmediatamente para establecer el estado inicial
    handleScroll();
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Función para hacer scroll a una sección
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 140; // Altura del header + submenu
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  // Funciones para navegar entre las tarjetas
  const nextCard = (setActiveCard, activeCard, maxCards) => {
    setActiveCard((activeCard + 1) % maxCards);
  };

  const prevCard = (setActiveCard, activeCard, maxCards) => {
    setActiveCard((activeCard - 1 + maxCards) % maxCards);
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO 
        title="OPUS - Módulo 5: Cuantificación BIM | ECOSOFT"
        description="Integración con modelos BIM para cuantificación y presupuestación automática de proyectos de construcción."
        keywords="OPUS, BIM, modelado, cuantificación, Revit, presupuestación, ingeniería de costos"
      />
      
      {/* Hero Section */}
      <section id="overview" className="relative h-[450px] bg-gradient-to-r from-[#003171] to-[#0066CC]" style={{
        backgroundImage: 'url("/images/modules/opus_m5/opusm5r.jpg")',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>
        <div className="absolute inset-0 bg-black/70"></div>
        <div className="container mx-auto px-4 h-full flex items-center pt-12 relative z-10">
          <div className="max-w-2xl text-white">
            <div className="flex items-center mb-6">
              <div className="relative w-32 h-32 mr-6 flex-shrink-0">
                <div className="absolute inset-[5%] bg-white rounded-full"></div>
                <img 
                  src="/images/m5.svg" 
                  alt="Módulo 5" 
                  className="w-full h-full relative z-10"
                />
              </div>
              <div className="flex flex-col justify-center">
                <h1 className="text-5xl font-bold">OPUS M5</h1>
                <h2 className="text-4xl font-bold mt-2">Cuantificación BIM</h2>
              </div>
            </div>
            <p className="text-xl mb-8">
              Cuantificación directa en TU MODELO de REVIT®. No hagas trabajo extra.
            </p>
            <div className="flex gap-4">
              <Link to="/soporte/descargas" className="bg-white text-[#0066CC] px-8 py-3 rounded-md font-semibold hover:bg-gray-100 transition-colors">
                Descargar
              </Link>
              <Link to="/Distribuidores" className="border-2 border-white text-white px-8 py-3 rounded-md font-semibold hover:bg-white/10 transition-colors">
                Ver demostración
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      {/* Submenu Navigation */}
      <div 
        className={`bg-white shadow-md transition-all duration-300 sticky-nav ${
          isSticky 
            ? 'fixed top-[64px] left-0 right-0 z-30 border-t border-gray-200' 
            : 'relative'
        }`}
        style={{ minHeight: '56px' }} // Altura mínima para evitar saltos
      >
        <div className="container mx-auto px-4 max-w-7xl">
          <div className="flex overflow-x-auto py-4 items-center relative">
            <div className="flex-grow flex">
              <button 
                onClick={() => scrollToSection('overview')}
                className={`px-6 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'overview' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Resumen
              </button>
              <button 
                onClick={() => scrollToSection('features')}
                className={`px-6 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'features' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Características
              </button>
              <button 
                onClick={() => scrollToSection('capabilities')}
                className={`px-6 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'capabilities' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Capacidades
              </button>
              <button 
                onClick={() => scrollToSection('benefits')}
                className={`px-6 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'benefits' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Beneficios
              </button>
              <button 
                onClick={() => scrollToSection('cta')}
                className={`px-6 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'cta' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Comenzar
              </button>
            </div>
            <div className="flex items-center ml-4">
              <img 
                src="/images/m5.svg" 
                alt="Módulo 5 - Cuantificación BIM" 
                className="h-12 w-auto"
              />
            </div>
          </div>
        </div>
      </div>
      
      {/* Features Section */}
      <section id="features" className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-[#1A2B39]">Características principales</h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaCubes className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Integración con plataformas BIM</h3>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Conexión directa con Autodesk Revit®</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Soporte para formatos IFC estándar</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Interoperabilidad con otras plataformas BIM</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Sincronización bidireccional de información</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Visualización 3D integrada</span>
                </li>
              </ul>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaRuler className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Cuantificación automática</h3>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Extracción de cantidades directamente del modelo</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Agrupación inteligente de elementos</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Cálculo automático de áreas, volúmenes y longitudes</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Actualización en tiempo real con cambios en el modelo</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Detección de conflictos y validación de cantidades</span>
                </li>
              </ul>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaExchangeAlt className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Presupuestación integrada</h3>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Vinculación entre elementos BIM y conceptos</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Generación automática de presupuestos</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Actualización dinámica con cambios en el modelo</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Comparación de escenarios y alternativas</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Reportes detallados de análisis de costos</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Capabilities Section */}
      <section id="capabilities" className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-3">Lo que puedes hacer con OPUS M5</h2>
          <p className="text-xl text-gray-600 text-center mb-10 max-w-3xl mx-auto">
            Descubre cómo OPUS M5 te ayuda a conectar tus modelos BIM con presupuestos y programaciones precisas.
          </p>
          
          <div className="space-y-12">
            {/* Capability 1 */}
            <div className="flex flex-col md:flex-row gap-6 items-center">
              <div className="w-full md:w-1/2 relative group">
                <img 
                  src={carouselData1[activeCard1].image} 
                  alt={carouselData1[activeCard1].title} 
                  className="rounded-lg shadow-lg w-full h-72 object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-between px-4 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button 
                    onClick={() => prevCard(setActiveCard1, activeCard1, carouselData1.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Anterior"
                  >
                    <FaChevronLeft size={20} />
                  </button>
                  <button 
                    onClick={() => nextCard(setActiveCard1, activeCard1, carouselData1.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Siguiente"
                  >
                    <FaChevronRight size={20} />
                  </button>
                </div>
              </div>
              <div className="w-full md:w-1/2">
                <h3 className="text-2xl font-bold mb-3 text-[#1A2B39]">{carouselData1[activeCard1].title}</h3>
                <p className="text-gray-600 mb-4">{carouselData1[activeCard1].description}</p>
                <ul className="space-y-2 mb-6">
                  {carouselData1[activeCard1].features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <FaCheck className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            
            {/* Capability 2 */}
            <div className="flex flex-col md:flex-row-reverse gap-6 items-center">
              <div className="w-full md:w-1/2 relative group">
                <img 
                  src={carouselData2[activeCard2].image} 
                  alt={carouselData2[activeCard2].title} 
                  className="rounded-lg shadow-lg w-full h-72 object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-between px-4 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button 
                    onClick={() => prevCard(setActiveCard2, activeCard2, carouselData2.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Anterior"
                  >
                    <FaChevronLeft size={20} />
                  </button>
                  <button 
                    onClick={() => nextCard(setActiveCard2, activeCard2, carouselData2.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Siguiente"
                  >
                    <FaChevronRight size={20} />
                  </button>
                </div>
              </div>
              <div className="w-full md:w-1/2">
                <h3 className="text-2xl font-bold mb-3 text-[#1A2B39]">{carouselData2[activeCard2].title}</h3>
                <p className="text-gray-600 mb-4">{carouselData2[activeCard2].description}</p>
                <ul className="space-y-2 mb-6">
                  {carouselData2[activeCard2].features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <FaCheck className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            
            {/* Capability 3 */}
            <div className="flex flex-col md:flex-row gap-6 items-center">
              <div className="w-full md:w-1/2 relative group">
                <img 
                  src={carouselData3[activeCard3].image} 
                  alt={carouselData3[activeCard3].title} 
                  className="rounded-lg shadow-lg w-full h-72 object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-between px-4 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button 
                    onClick={() => prevCard(setActiveCard3, activeCard3, carouselData3.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Anterior"
                  >
                    <FaChevronLeft size={20} />
                  </button>
                  <button 
                    onClick={() => nextCard(setActiveCard3, activeCard3, carouselData3.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Siguiente"
                  >
                    <FaChevronRight size={20} />
                  </button>
                </div>
              </div>
              <div className="w-full md:w-1/2">
                <h3 className="text-2xl font-bold mb-3 text-[#1A2B39]">{carouselData3[activeCard3].title}</h3>
                <p className="text-gray-600 mb-4">{carouselData3[activeCard3].description}</p>
                <ul className="space-y-2 mb-6">
                  {carouselData3[activeCard3].features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <FaCheck className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Benefits Section */}
      <section id="benefits" className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-[#1A2B39]">Ventajas de la integración BIM-OPUS</h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-[#F5F7FA] p-6 rounded-lg">
              <FaRuler className="text-[#0066CC] text-4xl mb-4" />
              <h3 className="text-xl font-bold mb-3 text-[#1A2B39]">Precisión</h3>
              <p className="text-gray-600">
                Elimina errores humanos en la cuantificación, proporcionando datos exactos del modelo.
              </p>
            </div>
            
            <div className="bg-[#F5F7FA] p-6 rounded-lg">
              <FaSync className="text-[#0066CC] text-4xl mb-4" />
              <h3 className="text-xl font-bold mb-3 text-[#1A2B39]">Ahorro de tiempo</h3>
              <p className="text-gray-600">
                Reduce hasta un 80% el tiempo dedicado a la cuantificación manual de proyectos.
              </p>
            </div>
            
            <div className="bg-[#F5F7FA] p-6 rounded-lg">
              <FaChartBar className="text-[#0066CC] text-4xl mb-4" />
              <h3 className="text-xl font-bold mb-3 text-[#1A2B39]">Actualización dinámica</h3>
              <p className="text-gray-600">
                Mantiene el presupuesto actualizado automáticamente con cada cambio en el modelo.
              </p>
            </div>
            
            <div className="bg-[#F5F7FA] p-6 rounded-lg">
              <FaLayerGroup className="text-[#0066CC] text-4xl mb-4" />
              <h3 className="text-xl font-bold mb-3 text-[#1A2B39]">Colaboración efectiva</h3>
              <p className="text-gray-600">
                Facilita la comunicación entre diseñadores, presupuestadores y constructores.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Integration with other modules */}
      <section className="py-16 bg-[#F5F7FA]">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-8 text-[#1A2B39]">Integración con otros módulos</h2>
          <p className="text-center text-gray-600 mb-12 max-w-3xl mx-auto">
            El Módulo 5 se integra perfectamente con el resto de OPUS para ofrecer una solución BIM completa
          </p>
          
          <div className="grid md:grid-cols-5 gap-6 max-w-5xl mx-auto">
            <Link to="/modulos/presupuesto-programable" className="bg-[#F5F7FA] p-5 rounded-lg text-center hover:bg-[#0066CC]/5 transition-colors">
              <h3 className="text-lg font-bold mb-2 text-[#1A2B39]">Módulo 1</h3>
              <p className="text-gray-600 text-sm">Presupuesto Programable</p>
              <div className="mt-3 h-1 w-full bg-[#0066CC] rounded"></div>
            </Link>
            
            <Link to="/modulos/planeacion-control" className="bg-[#F5F7FA] p-5 rounded-lg text-center hover:bg-[#0066CC]/5 transition-colors">
              <h3 className="text-lg font-bold mb-2 text-[#1A2B39]">Módulo 2</h3>
              <p className="text-gray-600 text-sm">Planeación y Control</p>
              <div className="mt-3 h-1 w-full bg-[#0066CC] rounded"></div>
            </Link>
            
            <Link to="/modulos/administracion-compras" className="bg-[#F5F7FA] p-5 rounded-lg text-center hover:bg-[#0066CC]/5 transition-colors">
              <h3 className="text-lg font-bold mb-2 text-[#1A2B39]">Módulo 3</h3>
              <p className="text-gray-600 text-sm">Administración de Compras</p>
              <div className="mt-3 h-1 w-full bg-[#0066CC] rounded"></div>
            </Link>
            
            <Link to="/modulos/dependencias" className="bg-[#F5F7FA] p-5 rounded-lg text-center hover:bg-[#0066CC]/5 transition-colors">
              <h3 className="text-lg font-bold mb-2 text-[#1A2B39]">Módulo 4</h3>
              <p className="text-gray-600 text-sm">Dependencias</p>
              <div className="mt-3 h-1 w-full bg-[#0066CC] rounded"></div>
            </Link>
            
            <Link to="/modulos/cuantificacion-bim" className="bg-[#F5F7FA] p-5 rounded-lg text-center border-2 border-[#0066CC] hover:bg-[#0066CC]/5 transition-colors">
              <h3 className="text-lg font-bold mb-2 text-[#1A2B39]">Módulo 5</h3>
              <p className="text-gray-600 text-sm">Cuantificación BIM</p>
              <div className="mt-3 h-1 w-full bg-[#0066CC] rounded"></div>
            </Link>
          </div>
        </div>
      </section>
      
      {/* Cursos y CERTIFICADOS */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-8 text-[#1A2B39]">Cursos y Certificados</h2>
          <p className="text-center text-gray-600 mb-12 max-w-3xl mx-auto">
            Fortalece tus conocimientos en OPUS Cuantificación BIM con nuestro programa de certificación
          </p>
          
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaCubes className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Curso básico</h3>
              <p className="text-gray-600 mb-4 text-center">
                Aprende los fundamentos de la cuantificación BIM integrada con presupuestos
              </p>
              <Link 
                to="/certificaciones" 
                className="block text-center px-6 py-2 bg-[#0066CC] text-white rounded-md hover:bg-[#0055AA] transition-colors mx-auto w-full"
              >
                Ver detalles
              </Link>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaRuler className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Curso avanzado</h3>
              <p className="text-gray-600 mb-4 text-center">
                Domina técnicas avanzadas de integración BIM-OPUS y automatización
              </p>
              <Link 
                to="/certificaciones" 
                className="block text-center px-6 py-2 bg-[#0066CC] text-white rounded-md hover:bg-[#0055AA] transition-colors mx-auto w-full"
              >
                Ver detalles
              </Link>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaLayerGroup className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Certificación oficial</h3>
              <p className="text-gray-600 mb-4 text-center">
                Obtén la certificación oficial ECOSOFT que valida tus conocimientos profesionales
              </p>
              <Link 
                to="/certificaciones" 
                className="block text-center px-6 py-2 bg-[#0066CC] text-white rounded-md hover:bg-[#0055AA] transition-colors mx-auto w-full"
              >
                Ver detalles
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section id="cta" className="py-16 bg-[#1A2B39] text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">¿Listo para integrar BIM con tus presupuestos?</h2>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Descubre todo el potencial de OPUS M5 Cuantificación BIM para optimizar y automatizar tus procesos de estimación.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link 
              to="/soporte/descargas" 
              className="px-8 py-3 bg-[#0066CC] hover:bg-[#0088FF] text-white font-medium rounded-md transition-colors"
            >
              Descargar
            </Link>
            <Link 
              to="/Distribuidores" 
              className="px-8 py-3 border border-white hover:bg-white hover:text-[#1A2B39] text-white font-medium rounded-md transition-colors"
            >
              Solicitar demostración
            </Link>
            <Link 
              to="/Distribuidores" 
              className="px-8 py-3 bg-white text-[#1A2B39] hover:bg-gray-100 font-medium rounded-md transition-colors"
            >
              Contactar con ventas
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CuantificacionBIM; 